export const topicIssues = [
    {
        key: 'consumptionIssue',
        label: 'Consumption issue',
        value: 'Consumption issue',
    },
    {
        key: 'hardwareProblems',
        label: 'Hardware problems',
        value: 'Hardware problems',
    },
     {
        key: 'anotherIssue',
        label: 'Another issue',
        value: 'Another issue',
    },

]